<template>
	<modal-confirmacao
		titulo-modal="Informativo"
		:mensagem="mensagemModal"
		:exibir="exibirModal"
		@cancelar="confirmarAcaoInformativaModal"
	>
		<template #acoes>
			<botao-primario nomeBotao="OK" @click="confirmarAcaoInformativaModal"></botao-primario>
		</template>
	</modal-confirmacao>
</template>
<script>
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'

export default {
	name: 'modal-informativo',
	components: { BotaoPrimario, ModalConfirmacao },

	props: {
		exibirModal: {
			type: Boolean,
			required: true,
		},
		mensagemModal: {
			type: String,
			required: true,
		},
	},
	methods: {
		confirmarAcaoInformativaModal() {
			this.$emit('confirmar-acao-informativo')
		},
	},
}
</script>
